<template>   
   <!-- <section class="fixed-bg" :style="addBG(background)"> -->
  <section class="fixed-bg">
    <div class="video-bg one abs-center">
      <img class="fixed-bg-img abs-center lazyload-bg" :src="background" />
    <!-- <iframe v-if="video" :src="video" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> -->
    </div>
    <div class="ph0 ph5-m ph5-l flex fixed-height realtive">
      <slot name="contents"></slot>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      background:{},
      video:{},
      height:{},
    },
     data () {
    return {
      videoSource: null,
      winWidth: null,
    }
  },
    methods: {
      addBG: function() {
        return 'background-image:url('+this.background+')';
      },
      width: function(){
        this.winWidth = window.innerWidth;
      }
    },
  }
</script>